import { Flashcard, FlashcardProps } from '../../domain/entities/Flashcard';
import { FlashcardDTO } from '../dto/FlashcardDTO';

export class FlashcardMapper {
  static toDTO(card: Flashcard): FlashcardDTO {
    return {
      id: card.id,
      deckId: card.deckId,
      front: card.front,
      back: card.back,
      sortOrder: card.sortOrder,
      tags: card.tags,
      createdAt: card.createdAt.toISOString(),
      updatedAt: card.updatedAt.toISOString(),
    };
  }

  static toDTOList(cards: Flashcard[]): FlashcardDTO[] {
    return cards.map(card => this.toDTO(card));
  }

  static fromDatabaseRow(row: Record<string, unknown>): Flashcard {
    const r = row as {
      id: number;
      deck_id: number;
      front: string;
      back: string;
      sort_order: number;
      tags: string[] | null;
      created_at: string;
      updated_at: string;
    };

    const props: FlashcardProps = {
      id: String(r.id),
      deckId: String(r.deck_id),
      front: r.front,
      back: r.back,
      sortOrder: r.sort_order,
      tags: r.tags || [],
      createdAt: new Date(r.created_at),
      updatedAt: new Date(r.updated_at),
    };
    return new Flashcard(props);
  }
}
